module.exports = __webpack_public_path__ + "a8434499d06e85014e94bcd6f90c0312.png";